import { CommonOption } from "api/modules/common.option";
import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const rialabelFields = ( 
  studyOptions: CommonOption[],
  periodOptions: CommonOption[],
  timepointOptions: CommonOption[],
  aliquotOptions: CommonOption[],
  selectedStudyId: number | null | string,
  selectedPeriod: number | null | string,
  selectedTimepoint: (number | string)[] | number | null | string,
  selectedAliquot?: (number | string)[] | number | null | string
): FormFieldConfig[] => [
    {
      name: "studyid",
      label: "Study Code",
      type: "select",
      options: studyOptions,
      placeholder: "Select Study Code",
      required: true,
      disabled: true,
      rules: validations.cryovialLabel.studyid,
    },
    {
      name: "period",
      label: "Period",
      type: "select",
      options: periodOptions,
      placeholder: "Select Period",
      required: true,
      disabled: !selectedStudyId,
      rules: validations.cryovialLabel.period,
    },
    {
      name: "timepoint",
      label: "Time Point",
      type: "select",
      options: timepointOptions,
      placeholder: "Select Time Point",
      required: true,
      disabled: !selectedPeriod,
      rules: validations.cryovialLabel.timepoint,
    },
    {
      name: "aliquot",
      label: "Aliquot Number",
      type: "select",
      options: aliquotOptions,
      placeholder: "Select Aliquot.No",
      required: true,
      disabled: !selectedTimepoint,
      rules: validations.cryovialLabel.aliquot,
    },
  ];

  export const rialabelColumns = (
    selectedSeparationIds: number[],
    toggleSelection: (data: any, checked: boolean) => void,
    isAllSelected?: boolean,
    handleSelectAll?: (isChecked: boolean) => void
  ) => [
    {
      key: "select",
      sticky: true,
      width: "50px",
      label: (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={isAllSelected || false}
            onChange={(e) => handleSelectAll?.(e.target.checked)}
          />
        </div>
      ),
      textCenter: true,
      render: (_: any, data: any) => (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            className="form-check-input mt-0 cursor-pointer"
            checked={selectedSeparationIds.includes(data.sampleseparationid)}
            onChange={(e) => toggleSelection(data, e.target.checked)}
          />
        </div>
      ),
    },
    {
      key: "subjectno",
      label: "Subject No",
      sticky: true,
      width: "110px",
      render: (val: any) =>
        Number(val) >= 1 && Number(val) <= 9
          ? String(val).padStart(2, "0")
          : val,
    },
    {
      key: "period_number",
      label: "Period",
    },
    {
      key: "timepoint_number",
      label: "Time Point",
    },
    {
      key: "aliquot_number",
      label: "Aliquot Number",
    },
    {
      key: "rialbarcode",
      label: "Barcode",
    },
  ];